import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { MessageLanguageSpecificContentLoadAction } from '../../domains/messageLanguageSpecificContent/actions.types';
import { getId } from '../../domains/messageLanguageSpecificContent/getId';

import { MessagesLanguageSpecificContent } from './types';

export const initialState: MessagesLanguageSpecificContent = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<MessagesLanguageSpecificContent, MessageLanguageSpecificContentLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.messagesLanguageSpecificContent);
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_PENDING':
      return moveToPending(state, [getId(action.payload.messageId, action.payload.targetLanguage)]);
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_REJECTED':
      return moveToRejected(
        state,
        [getId(action.payload.messageId, action.payload.targetLanguage)],
        action.payload.error
      );
    default:
      return state;
  }
};

export default reducer;
